<!--
  Component: Field Calculation Modal: Lookup Panel.
  Path:      Field - Calculation - Lookup.
-->

<template>
  <!-- Lookup Calculation. -->
  <div>
    <b-form-group label="Order of Calculation">
      <b-input id="configureFieldOrderOfCalculation" v-model="calculationData.orderOfCalculation"
        placeholder="Order of Calculation" type="number" />
    </b-form-group>

    <div>
      <div class="row text-center mb-3 font-weight-bold">
        <div class="col-sm-5">
          Source Field<span class="text-danger">&nbsp;*</span>
        </div>
        <div class="col-sm-5">
          Related Field<span class="text-danger">&nbsp;*</span>
        </div>
      </div>
      <lookup-pair v-for="(lookupPair, index) in calculationData.sourceRelatedFieldPair" :table="table"
        :lookupPair="lookupPair" :index="index" :key="index" class="lookup-relations row" />
      <!-- Button to add a Relation. -->
      <b-button title="Add a Relation" @click="addLookupPair">
        Add Relation
      </b-button>
    </div>
  </div>
</template>

<script>

import LookupPair from './LookupPair';

export default {

  name: 'LookupPanel',

  components: {
    LookupPair,
  },

  provide() {
    return {
      /** Remove a Lookup Pair from the list (by index). Used by LookupPair component. */
      deleteLookupPair: this.deleteLookupPair,
    };
  },

  inject: [
    /* Current Field. [from CalculationModel] */
    'tableField',
    /* Calculation data - to be populated with Lookup Pairs. [from CalculationModel] */
    'calculationData',
    /* Entity utility functions etc. [from CalculationModel] */
    'entityUtils',
  ],

  props: {
    table: Object,
  },

  data() {
    return {};
  },

  computed: {
  },

  methods: {

    /** Add a Lookup Pair to the list. */
    addLookupPair() {
      /* Ensure Calculation Data has complete set of reactive properties. */
      if (!this.calculationData.sourceRelatedFieldPair)
        this.$set(this.calculationData, 'sourceRelatedFieldPair', []);
      /* Add a Concatenation Item to the Calculation Data. */
      this.calculationData.sourceRelatedFieldPair.push({
        sourceField: '',
        relatedField: '',
      });
    },

    /**
     * Remove a Lookup Pair from the list.
     * @param index - Index of the Lookup Pair to be removed.
     */
    deleteLookupPair(index) {
      this.calculationData.sourceRelatedFieldPair = this.calculationData.sourceRelatedFieldPair.filter((el, idx) => idx !== index);
    },

  },

  /** Component's Reactive State is initialised but DOM not yet rendered. */
  beforeMount() {
    /* Ensure that at least one Concatenation Item in the list. */
    if (!this.calculationData.sourceRelatedFieldPair?.length)
      this.addLookupPair();
    if (!this.calculationData.hasOwnProperty('orderOfCalculation'))
      this.$set(this.calculationData, 'orderOfCalculation', 0);
  },

  mounted() {
  },

}

</script>

<style lang="scss" scoped>
.lookup-relations {
  margin-bottom: 1rem;
  padding-right: 15px;
  align-items: baseline;

  .form-group {
    margin-bottom: 0;
  }

  button {
    display: flex;
    align-self: end;
    justify-content: center;
  }
}
</style>